<template>
<div class="chapter">
<div class="inner_page">
<h1>Sumário</h1>
<p><a href="#/c001">Investindo no Amor | Lexy Timms</a></p>
<p><a href="#/c002">Todos os direitos reservados.</a></p>
<p><a href="#/c003">Copyright 2018 por Lexy Timms | Capa por: Book Cover by Design</a></p>
<p><a href="#/c004">Série Banqueiro Bilionário</a></p>
<p><a href="#/c005">Encontre Lexy Timms:</a></p>
<p><a href="#/c006">Investindo no Amor Sinopse</a></p>
<p><a href="#/c007">Capítulo 1</a></p>
<p><a href="#/c008">Capítulo 2</a></p>
<p><span href="#/c009" title="Link target outside of Sample">Capítulo 3</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Capítulo 4</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Capítulo 5</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Capítulo 6</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Capítulo 7</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Capítulo 8</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Capítulo 9</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Capítulo 10</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Capítulo 11</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Capítulo 12</span></p>
<p><span href="#/c019" title="Link target outside of Sample">Capítulo 13</span></p>
<p><span href="#/c020" title="Link target outside of Sample">Capítulo 14</span></p>
<p><span href="#/c021" title="Link target outside of Sample">Capítulo 15</span></p>
<p><span href="#/c022" title="Link target outside of Sample">Série Banqueiro Bilionário</span></p>
<p><span href="#/c023" title="Link target outside of Sample">Conhecendo Seu Valor Sinopse</span></p>
<p><span href="#/c024" title="Link target outside of Sample">LEITURAS GRATUITAS?</span></p>
<p><span href="#/c025" title="Link target outside of Sample">Mais por Timms:</span></p>
<p><span href="#/c026" title="Link target outside of Sample">TOQUE FRÁGIL</span></p>
<p><span href="#/c027" title="Link target outside of Sample">Fingindo Descrição:</span></p>
<p><span href="#/c028" title="Link target outside of Sample">Quente e Bonito, Rico &amp; Solteiro...quão longe você está disposto a ir?</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1b941c7e